import { useMemo } from 'react';

import { useThemeContext } from 'global/ThemeContext/ThemeContext';
import { useIframeCommunication } from 'hooks/useIframeCommunication';
import { apiEducationNext } from 'microfrontends/config/api';
import { buildThemeParams } from 'microfrontends/config/theme';
('use client');

const Courses = () => {
  const theme = useThemeContext();

  const themeParams = useMemo(() => buildThemeParams(theme), [theme]);

  const getOrganizationUuid = () => {
    try {
      const orgUuid = localStorage.getItem('x-organization-uuid');
      if (!orgUuid) {
        console.warn('Organization UUID not found in localStorage');
        return '';
      }
      return orgUuid;
    } catch (error) {
      console.error('Error accessing localStorage:', error);
      return '';
    }
  };

  const baseUrl = useMemo(() => {
    const orgUuid = getOrganizationUuid();
    const url = new URL(`${apiEducationNext}/education-platform/education/admin/courses`);
    url.searchParams.append('organization_uuid', orgUuid);
    return url.toString();
  }, []);

  const iframeUrl = useMemo(() => {
    const url = new URL(baseUrl);
    const themeParamsObj = new URLSearchParams(themeParams);
    themeParamsObj.forEach((value, key) => {
      url.searchParams.append(key, value);
    });
    return url.toString();
  }, [baseUrl, themeParams]);

  const { iframeRef } = useIframeCommunication(iframeUrl);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
      }}
    >
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        style={{
          flex: 1,
          minHeight: '1000px',
          border: 'none',
        }}
        width="100%"
        title="Education Platform - Courses"
      />
    </div>
  );
};

export default Courses;
